import { type EnvironmentConfig } from '@/types/environment';

const devEnvironment: EnvironmentConfig = {
    VITE_APIGEE_API: 'https://api-dev.gls-group.net',
    VITE_APIGEE_API_VERSION: '/attribute-store-v1/api/v1',
    VITE_APIGEE_API_VERSION_V2: '/attribute-store-v2/api/v2',
    VITE_AZURE_AD_CLIENT_ID: '94f7808a-d2dd-4163-8834-a163d7138de0'
};

const stageEnvironment: EnvironmentConfig = {
    VITE_APIGEE_API: 'https://api-qas.gls-group.net',
    VITE_APIGEE_API_VERSION: '/attribute-store-v1/api/v1',
    VITE_APIGEE_API_VERSION_V2: '/attribute-store-v2/api/v2',
    VITE_AZURE_AD_CLIENT_ID: '94f7808a-d2dd-4163-8834-a163d7138de0'
};

const mt1Environment: EnvironmentConfig = {
    VITE_APIGEE_API: 'https://api-qas.gls-group.net',
    VITE_APIGEE_API_VERSION: '/mt1-attribute-store-v1/api/v1',
    VITE_APIGEE_API_VERSION_V2: '/attribute-store-v2/api/v2',
    VITE_AZURE_AD_CLIENT_ID: '94f7808a-d2dd-4163-8834-a163d7138de0'
};

const prodEnvironment: EnvironmentConfig = {
    VITE_APIGEE_API: 'https://api.gls-group.net',
    VITE_APIGEE_API_VERSION: '/attribute-store-v1/api/v1',
    VITE_APIGEE_API_VERSION_V2: '/attribute-store-v2/api/v2',
    VITE_AZURE_AD_CLIENT_ID: '6c7c9e6e-cd1e-49b8-b0b8-7acdd0268355'
};

export { devEnvironment, stageEnvironment, mt1Environment, prodEnvironment };
